export const testSmartAds = [
    {
        "filePath": "/UsersFiles/SmartAdds/1bf4a9b2-975e-451a-8b1c-e944ee78e7b3.jpg",
        "id": 3703,
        "isOrganization": true,
        "isActive": true,
        "position": "top center",
        "text": "#FF0000",
        "type": 4,
        "url": ""
    },
    {
        "filePath": "/UsersFiles/SmartAdds/f45a6f8c-31de-46b6-bcbe-5c2ccaa50fb5.jpg",
        "id": 3704,
        "isOrganization": true,
        "isActive": true,
        "position": "top left",
        "text": "Want to know more about EFMD ?",
        "type": 3,
        "url": "http://academy.capgemini.com"
    },
    {
        "filePath": "",
        "id": 3705,
        "isOrganization": true,
        "isActive": true,
        "position": "top right",
        "text": "",
        "type": 2,
        "url": "https://youtu.be/OBSBuklhSRE"
    },
    {
        "filePath": "/UsersFiles/SmartAdds/f45a6f8c-31de-46b6-bcbe-5c2ccaa50fb5.jpg",
        "id": 3704,
        "isOrganization": true,
        "isActive": true,
        "position": "bottom left",
        "text": "Want to know more about EFMD ?",
        "type": 3,
        "url": "http://academy.capgemini.com"
    },
    {
        "filePath": "/UsersFiles/SmartAdds/f45a6f8c-31de-46b6-bcbe-5c2ccaa50fb5.jpg",
        "id": 3704,
        "isOrganization": true,
        "isActive": true,
        "position": "bottom right",
        "text": "Want to know more about EFMD ?",
        "type": 3,
        "url": "http://academy.capgemini.com"
    }
]

export const publicDocumentTest = {
    "organizationName": "TEST organization (short)",
    "blockChainReceiptUrl": "https://Development.cvtrust.com/GetFile.aspx?ft=Custom1&fileGuidId=1|8d6595ef-6f49-4669-895f-d32b097e22da|6f46745d-1e69-4d02-9602-9695c797a5fa",
    "documentImageUrl": "https://Development.cvtrust.com/GetFile.aspx?ft=Custom3&fileGuidId=1|8d6595ef-6f49-4669-895f-d32b097e22da|6f46745d-1e69-4d02-9602-9695c797a5fa",
    "documentPdfUrl": "https://Development.cvtrust.com/GetPdf.aspx?1|8d6595ef-6f49-4669-895f-d32b097e22da|6f46745d-1e69-4d02-9602-9695c797a5fa",
    "createDate": "2022-03-29:01:20:01",
    "documentRowId": 305657,
    "emissionDate": "",
    "isBlockChain": false,
    "isBlockChainSigned": false,
    "isDocumentLandscape": true,
    "isDocumentSigned": true,
    "isDemo": false,
    "isPrivate": false,
    "isSuccess": true,
    "isVerified": false,
    "keywords": "test de test, badaboummmmm, js, html, css",
    "blockChainReceiptData": "",
    "originalDocumentImageUrl": "https://Development.cvtrust.com/GetFile.aspx?ft=Custom2&fileGuidId=1|8d6595ef-6f49-4669-895f-d32b097e22da|6f46745d-1e69-4d02-9602-9695c797a5fa",
    "folderName": "Pre-made templates",
    "folderTitle": "Pre-made templates",
    "smartads": [{
        "filePath": "/UsersFiles/SmartAdds/1bf4a9b2-975e-451a-8b1c-e944ee78e7b3.jpg",
        "id": 3703,
        "isOrganization": true,
        "isActive": true,
        "position": "top center",
        "text": "#FF0000",
        "type": 4,
        "url": ""
    },
    {
        "filePath": "/UsersFiles/SmartAdds/f45a6f8c-31de-46b6-bcbe-5c2ccaa50fb5.jpg",
        "id": 3704,
        "isOrganization": true,
        "isActive": true,
        "position": "top left",
        "text": "Want to know more about EFMD ?",
        "type": 3,
        "url": "http://academy.capgemini.com"
    },
    {
        "filePath": "",
        "id": 3705,
        "isOrganization": true,
        "isActive": true,
        "position": "top right",
        "text": "",
        "type": 2,
        "url": "https://youtu.be/OBSBuklhSRE"
    },
    {
        "filePath": "/UsersFiles/SmartAdds/f45a6f8c-31de-46b6-bcbe-5c2ccaa50fb5.jpg",
        "id": 3704,
        "isOrganization": true,
        "isActive": true,
        "position": "bottom left",
        "text": "Want to know more about EFMD ?",
        "type": 1,
        "url": "http://academy.capgemini.com"
    },
    {
        "filePath": "/UsersFiles/SmartAdds/f45a6f8c-31de-46b6-bcbe-5c2ccaa50fb5.jpg",
        "id": 3704,
        "isOrganization": true,
        "isActive": true,
        "position": "bottom right",
        "text": "Want to know more about EFMD ?",
        "type": 4,
        "url": "http://academy.capgemini.com"
    }],
    "recipientName": "Toto Jojo"
}


// WEBPACK FOOTER //
// ./src/modules/documents/models/_tests.js